export default __webpack_public_path__ + "static/media/(9).b17d5c55.jpeg";